
import isURL from "validator/lib/isURL";
import tlds from "tlds";

const URL_VALIDATION_OPTIONS = {
  protocols: ["http", "https"],
  require_protocol: false,
  require_valid_protocol: true,
  require_host: true,
  require_tld: true,
};


const VALID_TLDS = new Set(tlds);

const getTld = (value) => {
  let host = value.trim();
  host = host.replace(/^[a-z][a-z\d+.-]*:\/\//i, "");
  host = host.replace(/^[^@/]*@/, "");
  host = host.split("/")[0].split("?")[0].split("#")[0];
  host = host.split(":")[0];
  host = host.replace(/\.+$/, "");
  const labels = host.split(".");
  return labels[labels.length - 1].toLowerCase();
};


export const isValidUrl = (value) => {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (!isURL(trimmed, URL_VALIDATION_OPTIONS)) return false;
  return VALID_TLDS.has(getTld(trimmed));
};

export default isValidUrl;
